import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-component',
  templateUrl: './editor-component.component.html',
  styleUrls: ['./editor-component.component.scss']
})
export class EditorComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
